import { z } from 'zod'

import { BaseNumber } from '../types/BaseNumber.js'

export const baseNumberSchema = z.string().transform((value, ctx) => {
  try {
    return BaseNumber(value)
  } catch {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: `Invalid base number: ${value}`,
    })
    return z.NEVER
  }
})
